import {LayoutFeaturesList} from './LayoutFeaturesList';
import {LayoutFeaturesMetrics} from './LayoutFeaturesMetrics';
import {LayoutFeaturesTable} from './LayoutFeaturesTable';

import {prebuiltLayoutPreviewImages} from '../constants';

const category = 'Features';

export const FeaturesList = {
  category,
  displayName: 'Features List',
  previewImageURL: prebuiltLayoutPreviewImages.layoutFeaturesList,
  layout: LayoutFeaturesList,
};

export const FeaturesMetrics = {
  category,
  displayName: 'Features Metrics',
  previewImageURL: prebuiltLayoutPreviewImages.layoutFeaturesMetrics,
  layout: LayoutFeaturesMetrics,
};

export const FeaturesTable = {
  category,
  displayName: 'Features Table',
  previewImageURL: prebuiltLayoutPreviewImages.layoutFeaturesTable,
  layout: LayoutFeaturesTable,
};
